import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { oidcAuthApiRef } from '../apis';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => {
          const configApi = useApi(configApiRef);
          if (configApi.getString('auth.environment') === 'development') {
            return (
              <SignInPage
                {...props}
                providers={[
                  'guest',
                  {
                    id: 'oidc-auth-provider',
                    title: 'CIID',
                    message: 'Sign in using OIDC',
                    apiRef: oidcAuthApiRef,
                  },
                ]}
              />
            );
          }
          return (
            <SignInPage
              {...props}
              providers={[
                {
                  id: 'oidc-auth-provider',
                  title: 'CIID',
                  message: 'Sign in using OIDC',
                  apiRef: oidcAuthApiRef,
                },
              ]}
            />
          );
        },
      },
    }),
  ],
});
